import React, { useContext } from "react"
import { Div, Text } from "atomize"
import { useLocation } from "react-router-dom"
import { theme } from "../settings/config"
import { lessonsContext } from "../providers/lessons.provider"
import { themeContext } from "../providers/theme.provider"
import SegmentedPill from "../atoms/SegmentedPill"
import Divider from "../atoms/Divider"

const VIEW_OPTIONS = [
	{ value: "day", text: "Giorno" },
	{ value: "week", text: "Settimana" },
]

const OTHER_SCHOOLS_OPTIONS = [
	{ value: false, text: "Nascondi" },
	{ value: true, text: "Mostra" },
]

const THEME_OPTIONS = [
	{ value: "auto", text: "Auto" },
	{ value: "light", text: "Chiaro" },
	{ value: "dark", text: "Scuro" },
]

// In fondo alla barra laterale del computer, le due scelte che si cambiano
// mentre si lavora: come guardare le lezioni e il tema. Sul telefono la
// prima sta nella fascia in cima e il tema nel profilo; qui la
// barra laterale ha spazio vuoto, e sotto la griglia della settimana no.
//
// La vista è quella del momento: da quale si parte si sceglie nel profilo.
function SidebarSettings() {
	const location = useLocation()
	const {
		lessonsView,
		setLessonsView,
		setLessonToOpen,
		otherSchoolIDs,
		showOtherSchools,
		setShowOtherSchools,
	} = useContext(lessonsContext)
	const { mode, setMode } = useContext(themeContext)
	const isLessons = location.pathname === "/lessons"

	const label = text => (
		<Text
			textSize="tiny"
			textColor={theme.colors.text_light}
			m={{ b: "0.25rem", l: "0.25rem" }}
			style={{ textTransform: "uppercase", letterSpacing: "0.06em" }}>
			{text}
		</Text>
	)

	return (
		<Div d="flex" flexDir="column" style={{ gap: "1rem" }} m={{ b: "1.5rem" }}>
			{/* le impostazioni non sono posti dove andare: un filo le stacca
			    dalle voci di navigazione */}
			<Divider w="2px solid" m="0" />
			{/* la vista serve solo alle lezioni, ma il suo posto resta occupato
			    anche altrove: se sparisse, la barra si riassesterebbe e le voci
			    di navigazione salterebbero su e giù a ogni cambio di sezione */}
			<Div
				aria-hidden={!isLessons}
				style={{ visibility: isLessons ? "visible" : "hidden" }}>
				{label("Vista")}
				<SegmentedPill
					options={VIEW_OPTIONS}
					selected={lessonsView}
					onChange={view => {
						setLessonToOpen(null)
						setLessonsView(view)
					}}
				/>
			</Div>
			{/* le ore negli altri circoli, da accendere e spegnere mentre si
			    guarda la settimana; quali circoli, si sceglie nel profilo */}
			{otherSchoolIDs.length > 0 && (
				<Div
					aria-hidden={!isLessons}
					style={{ visibility: isLessons ? "visible" : "hidden" }}>
					{label("Altri circoli")}
					<SegmentedPill
						options={OTHER_SCHOOLS_OPTIONS}
						selected={showOtherSchools}
						onChange={setShowOtherSchools}
					/>
				</Div>
			)}
			<Div>
				{label("Tema")}
				<SegmentedPill options={THEME_OPTIONS} selected={mode} onChange={setMode} />
			</Div>
		</Div>
	)
}

export default SidebarSettings
